import { ApprovalAiIcon } from '@/components/icons';
import type { ApprovalRowSchema } from '@/flows/types';

interface ApprovalSummaryProps<TDraft> {
  title?: string;
  draft: TDraft;
  rows: ApprovalRowSchema<TDraft>[];
  aiFilledFields?: string[];
  onBack: () => void;
  onApprove: () => void;
  disabled?: boolean;
  backLabel?: string;
  approveLabel?: string;
  showApproveButton?: boolean;
}

export function ApprovalSummary<TDraft>({
  title = 'Review and confirm',
  draft,
  rows,
  aiFilledFields = [],
  onBack,
  onApprove,
  disabled = false,
  backLabel = 'Back',
  approveLabel = 'Confirm',
  showApproveButton = true,
}: ApprovalSummaryProps<TDraft>) {
  return (
    <section className="approval-card" aria-labelledby="approval-title">
      <h3 id="approval-title" className="approval-card__title">
        {title}
      </h3>
      <div className="approval-card__fields">
        {rows.map((row) => {
          const showSparkle = Boolean(row.aiField && aiFilledFields.includes(row.aiField));
          return (
            <div key={row.key} className="approval-card__field">
              <span className="approval-card__key">
                {row.key}
                {showSparkle ? <ApprovalAiIcon className="approval-card__sparkle" size={18} /> : null}
              </span>
              <span className="approval-card__value">{row.value(draft) || '—'}</span>
            </div>
          );
        })}
      </div>
      <div className="approval-card__actions">
        <button type="button" className="form-kit__btn" onClick={onBack}>
          {backLabel}
        </button>
        {showApproveButton ? (
          <button
            type="button"
            className="form-kit__btn form-kit__btn--primary"
            onClick={onApprove}
            disabled={disabled}
          >
            {approveLabel}
          </button>
        ) : null}
      </div>
    </section>
  );
}
